<template>
  <SeoBlogArticle :content="$t('seoArticleOQueEUtmCampaign')"/>
</template>
<script>
import SeoBlogArticle from "../fragments/SeoBlogArticle.vue";
export default {
  name: 'ArticleOQueEUtmCampaign',
  components: { SeoBlogArticle },
}
</script>
